import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
export function ClosingSection() {
  return <section className="section wash closing" aria-labelledby="closing-heading" data-id="element-23" data-mp="ounb6xmzo6p8">
      <div className="shell" data-id="element-24" data-mp="12twtc2ur9avu">
        <p className="eyebrow" data-id="element-25" data-mp="12qr0ccj09ouu">YOUR NEXT SESSION</p>
        <h2 id="closing-heading" data-id="element-26" data-mp="xthdn4n03rap">
          Your next team communication workshops.
          <br data-id="element-27" data-mp="1cqhwein7sbx1" />
          <span data-id="element-28" data-mp="1cq84gpilzuop">Already planned for you.</span>
        </h2>
        <p data-id="element-29" data-mp="1coooz14s1nnz">
          Volume 1: five workshops with facilitator wording, realistic cases and observation sheets — so your
          preparation is reading and printing, not writing from scratch.
        </p>
        <CtaButton href="#offer-details" data-id="element-30" data-mp="1hhq51cgpzt95">
          See the complete plan — $27 <ArrowRightIcon size={19} aria-hidden="true" data-id="element-31" data-mp="1hije4k35iuug" />
        </CtaButton>
        <p className="cta-note" data-id="element-32" data-mp="1viarcilug77e">USD · One-time payment · English-language PDFs</p>
      </div>
    </section>;
}